import {addToCartHandler} from "./addToCart";
import app from "../_app";
import {adpObserver} from "./adp";
import {recentProducts} from "./recently-viewed";

const product = document.querySelector('.js-product');

if(product) {
    const form = product.querySelector('.js-product-form');
    const price = product.querySelector('.js-product-price');
    const compareAtPrice = product.querySelector('.js-product-compare-at-price');
    const compareAtPriceLabel = product.querySelector('.js-product-label');

    const variants = [...product.querySelectorAll('.js-product-variant')];
    const currentVariantLabels = [...document.querySelectorAll('.js-product-variant-label')];

    const variantsElement = product.querySelector('.js-product-variants');
    const variantsTriggers = [...product.querySelectorAll('.js-product-variants-trigger')];

    const addToCartContainer = product.querySelector('.js-product-add-to-cart-container');

    const variantChangeHandler = ({currentTarget}, withUrlChange = true) => {
        if(currentTarget) {
            const {dataset} = currentTarget;

            if(withUrlChange) {
                const newVariantUrl = new URL(window.location);
                newVariantUrl.searchParams.set('variant', currentTarget.value);
                window.history.pushState({}, '', newVariantUrl);
            }

            price.setAttribute('data-price', dataset.price);

            if(dataset.compareAtPrice) {
                compareAtPrice.setAttribute('data-price', dataset.compareAtPrice);

                price.classList.add('c--r');
                compareAtPrice.classList.remove('d-none');

                if(compareAtPriceLabel) {
                    compareAtPriceLabel.classList.remove('d-none');
                }
            } else {
                price.classList.remove('c--r');
                compareAtPrice.classList.add('d-none');

                if(compareAtPriceLabel) {
                    compareAtPriceLabel.classList.add('d-none');
                }
            }

            currentVariantLabels.map(label => label.innerText = dataset.label);


            updateVariantStaffel(dataset.price);

            if(app.viewport.isSmallerThan('lg')) {
                variantsTriggerClickHandler(true);
            }
        }
    };

    const updateVariantStaffel = (price, attempts = 0) => {
        if (window.appikon && window.appikon.product && window.appikonDiscount && window.appikonDiscount.loadProductPageApi) {
            adpObserver.observe(form, {childList: true});

            window.appikon.product.variant_price = price;
            window.appikonDiscount.loadProductPageApi();
        } else if (attempts < 5) {
            setTimeout(() => {
                updateVariantStaffel(price, attempts + 1);
            }, 100);
        }
    }

    const variantsTriggerClickHandler = (forceClose = false) => {
        if(forceClose === true || variantsElement.hasAttribute('data-open')) {
            //variantsElement.removeAttribute('data-open');
            app.unlockBody();
        } else {
            app.lockBody();
            variantsElement.setAttribute('data-open', '');
        }
    }

    const addToCartScrollHandler = () => {
        const {top, height} = addToCartContainer.getBoundingClientRect();

        if(top + height < 0) {
            addToCartContainer.setAttribute('data-sticky', '');
        } else {
            addToCartContainer.removeAttribute('data-sticky')
        }
    }

    form.addEventListener('submit', addToCartHandler);

    setTimeout(() => {
        let currentTarget = variants[0];

        if(variants.length > 1) {
            currentTarget = variants.find(variant => variant.checked);
        }

        variantChangeHandler({currentTarget}, false);
    }, 1);

    variants.map(variant => variant.addEventListener('change', variantChangeHandler));

    window.onpopstate = () => {
        let variant;
        const variantUrl = new URLSearchParams(window.location.search);

        if(variantUrl.get('variant')) {
            variant = document.querySelector(`.js-product-variant[value="${variantUrl.get('variant')}"]`);
        } else {
            variant = document.querySelector(`.js-product-variant:not(:disabled)`);
        }

        if(variant) {
            variant.checked = true;
            variantChangeHandler({currentTarget: variant}, false);
        }
    }

    if(app.viewport.isSmallerThan('lg')) {
        variantsTriggers.map(variantsTrigger => variantsTrigger.addEventListener('click', variantsTriggerClickHandler));

        addToCartContainer.style.setProperty('--h', `${addToCartContainer.clientHeight}px`);
        addToCartScrollHandler();
        window.addEventListener('scroll', addToCartScrollHandler);
    }

    const articleNumbers = product.querySelector('.js-product-article-numbers');
    let limit = 6;

    if(app.viewport.isEqualOrGreaterThan('lg')) {
        limit = 9;
    }else if(app.viewport.isEqualOrGreaterThan('xl')) {
        limit = 12;
    }

    if(articleNumbers) {
        if(articleNumbers.querySelectorAll('span').length <= limit){
            product.querySelector('.js-readmore').remove();
        }
    }

    recentProducts(product.dataset.handle);
}
